import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';
import { Http, Headers, RequestOptions, Response } from "@angular/http";
import { environment } from '../../../../environments/environment';
import { ITableModel } from '../table/model/tableModel';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
declare const tf: any;
declare const cocoSsd: any;


@Component({
  selector: 'app-new-bulk-order-upload',
  templateUrl: './new-bulk-order-upload.component.html',
  styleUrls: ['./new-bulk-order-upload.component.scss']
})
export class NewBulkOrderUploadComponent implements OnInit {

  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Input() BookingId:any;
  userId:any;
  CompanyId: any;
  SelectedCompanyGSTCode: any;
  TenantId: any;
  @Output() OnRefreshParent = new EventEmitter<string>();
  @ViewChild('fileInput') fileInput: ElementRef;
  model: any;
  loadingModel = false;
  OCRExtractedData: any = [];
  UploadedData: any = {};

  tableDetails: ITableModel = {
    emptyDataMSg: "No orders uploaded yet. Click “Upload Orders” to get started.",
    columnDetails: [
      { columnName: "Sr.No", dataFieldName: "SRNo",},
      { columnName: "Container No", dataFieldName: "containerNumber",},
      { columnName: "Seal No", dataFieldName: "sealNumbers",},
      { columnName: "Scan", dataFieldName: "scanLines",},
      { columnName: "Trip Date", dataFieldName: "tripDate",},
      { columnName: "Customer", dataFieldName: "customer",},
      { columnName: "Origin", dataFieldName: "origin",},
      { columnName: "Destination", dataFieldName: "destination",},
      { columnName: "Vehicle No", dataFieldName: "truckNumber",},
      { columnName: "Vehicle Type", dataFieldName: "size",},
      { columnName: "Transport Service", dataFieldName: "transportService",},
      { columnName: "Weight", dataFieldName: "weight", alignType: "right"},
      { columnName: "Diesel Taken", dataFieldName: "dieselTaken",},
      { columnName: "Driver", dataFieldName: "driverName",},
      { columnName: "Reason", dataFieldName: "Reason",},
      { columnName: "View EIR Copy", dataFieldName: "eircopy",divType:'UploadOrderBulkEIRView'},
      { columnName: "Actions", dataFieldName: '', divType: 'TyreAssignaction', },
    ],
    data: [],
    footerData: [],
    actionList: [
      { label: 'Edit', command: (event?: any) => console.log(event) },
      { label: 'Delete', }
    ],
    isColumnNameShow: true,
    isShowFooterData: false,
  };

  @ViewChild('EditOrder') EditOrder: TemplateRef<any>;
  @ViewChild('failedModal') failedModal: TemplateRef<any>;
   modalRef: NgbModalRef | null = null;
  
  selectedData:any = {};
  selectedIndex: any = 0;
  today: any = new Date();

  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router,
    private anghttp: Http,
    private cd: ChangeDetectorRef,
    private modalService: NgbModal,
    public datepipe: DatePipe,
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId")))
    );
    this.UploadedData.TotalFiles = 0;
    this.UploadedData.UploadSuccess = 0;
    this.UploadedData.UploadFailed = 0;
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

   async onFilesSelected(event: any) {
    const files = Array.from(event.target.files) as File[];
    if (!files.length) return;

    Helpers.setLoading(true);
    this.cd.detectChanges(); // Force Angular to update the DOM
    await new Promise(res => setTimeout(res, 50));

    // Fetch dropdown lists once
    await Promise.all([
      // this.GetCustomerList(),
      // this.GetOriginList(),
      // this.GetDestinationList(),
      // this.GetVehicleNoList(),
      // this.GetVehicleTypeList(),
      // this.GetTransportServiceList(),
      // this.GetDriverList()
    ]);

    // Initialize array to hold all results in correct order
    // this.OCRExtractedData = new Array(files.length).fill(null);

    // ✅ Process sequentially to maintain index mapping
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      try {
        const dataUrl = await this.readFileAsDataURL(file);
        const croppedDataUrl = await this.detectAndCrop(dataUrl);
        const finalDataUrl = croppedDataUrl || dataUrl;

        const blob = await this.dataURLToBlob(finalDataUrl);
        const filePhoto = new File([blob], file.name, { type: blob.type });

        const result = await this.uploadSingleImage(filePhoto);
        if (!result || !result.selectedOutput || !result.selectedOutput.length) {
          console.warn(`No OCR data for ${file.name}`);
          continue;
        }

        // ✅ Always use index to ensure correct image mapping
        await this.handleExtractedData(result, filePhoto, index);

      } catch (err) {
        console.error(`Error processing file ${file.name}:`, err);
        Helpers.setLoading(false);
        await this.toastr.error(`Image ${file.name} upload failed.`, 'Error');
      }
    }

    await this.toastr.success('All images uploaded successfully.', 'Success');
    Helpers.setLoading(false);
    event.target.value = ''; // Reset input
  }

  async handleExtractedData(result: any, filePhoto: File, index: number): Promise<void> {
    return new Promise<void>((resolve) => {
      if (!result || !result.selectedOutput || result.selectedOutput.length === 0) {
        resolve();
        return;
      }

      // Helpers.setLoading(true);
      // Loop through all OCR outputs (EXPORT / IMPORT etc.)
      result.selectedOutput.forEach((element: any, i: number) => {

        // --- 🔹 Normalize data ---
        if (element.headerName === 'EIR-Receive Export') element.origin = 'N/A';
        if (element.headerName === 'EIR-Receive Import Empty Container') element.destination = 'N/A';
        if (
          element.headerName === 'Import Empty Container' &&
          (element.destination === 'MTYMSK' || element.destination === 'MTYMSA')
        ) {
          element.destination = 'N/A';
        }

        // --- 🔹 Handle image file ---
        let fileFromApi: File | null = null;
        if (result.imageBase64) {
          const blob = this.dataURLToBlob(result.imageBase64);
          fileFromApi = new File(
            [blob],
            result.fileName || `ocr_${index}_${i}.jpg`,
            { type: blob.type }
          );
          element.eircopy = fileFromApi; // image from API
          console.log(`image from API for container ${element.containerNumber}`);
        } else {
          element.eircopy = filePhoto; // fallback to local file
          console.log(`fallback to local File for container ${element.containerNumber}`);
        }

        // --- 🔹 Store result in correct array slot ---
        // If multiple containers come from the same image, store them sequentially
        const targetIndex = index + i;

        const missingFields: string[] = [];
        const requiredFields = [
          { key: "containerNumber", label: "Container Number" },
          // { key: "sealNumbers", label: "Seal Number" },
          // { key: "scanLines", label: "Scan Lines" },
          { key: "tripDate", label: "Trip Date" },
          { key: "customer", label: "Customer" },
          { key: "origin", label: "Origin" },
          { key: "destination", label: "Destination" },
          { key: "truckNumber", label: "Truck Number" },
          { key: "size", label: "Size" },
          { key: "transportService", label: "Transport Service" },
          { key: "weight", label: "Weight" },
        ];
        requiredFields.forEach(f => {
          if (
            element[f.key] === null ||
            element[f.key] === undefined ||
            element[f.key] === "" ||
            (typeof element[f.key] === "string" && element[f.key].trim() === "")
          ) {
            missingFields.push(`${f.label} is empty`);
          }
        });
        if (missingFields.length > 0) {
          element.Reason = missingFields.join(", ");
          element.IsUploadSuccess = false;
        } else {
          element.Reason = "";
          element.IsUploadSuccess = true;
        }

        // element.SRNo= i+1;
        this.OCRExtractedData.push(element);
        this.tableDetails.data.push(element);
        this.tableDetails.data = this.tableDetails.data.map((item, index) => {
          return {
            ...item,
            SRNo: index + 1
          };
        });

        var up_success = this.OCRExtractedData.filter(x => x.IsUploadSuccess === true).length;
        this.UploadedData.UploadSuccess = up_success;
        this.UploadedData.UploadFailed = parseFloat(this.OCRExtractedData.length) - parseFloat(up_success);
        // --- 🔹 Update dropdowns/UI for each row ---
        // setTimeout(() => {
        //   this.refreshSelect2ForRow(targetIndex, element);
        // }, 300);
      });

      resolve();
      // Helpers.setLoading(false);
    });
  }

  dataURLToBlob(dataURL: string): Blob {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new Blob([u8arr], { type: mime });
  }

  readFileAsDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

   async detectAndCrop(imageDataUrl: string): Promise<string | null> {
    if (!imageDataUrl) return null;

    await this.loadModel();

    const img = new Image();
    img.src = imageDataUrl;
    // await img.decode();
    await new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = (e) => reject(e);
    });

    console.log('🔍 Detecting objects for image:', img.width, 'x', img.height);

    let predictions: any[] = [];
    try {
      predictions = await this.model!.detect(img);
    } catch (err) {
      console.error('TensorFlow detection error:', err);
      return null;
    }

    await new Promise((res) => setTimeout(res, 100)); // GPU cooldown

    if (!predictions || predictions.length === 0) {
      console.warn('⚠️ No objects detected for this image');
      return null;
    }

    // Find largest bounding box
    const largest = predictions.reduce((prev, curr) => {
      const a1 = prev.bbox[2] * prev.bbox[3];
      const a2 = curr.bbox[2] * curr.bbox[3];
      return a2 > a1 ? curr : prev;
    }, predictions[0]);

    const [x, y, width, height] = largest.bbox;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(width);
    canvas.height = Math.round(height);
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;

    ctx.drawImage(img, x, y, width, height, 0, 0, width, height);
    const croppedDataUrl = canvas.toDataURL('image/png');

    console.log('✅ Cropping done for this image');
    return croppedDataUrl;
  }

  async loadModel() {
    if (this.model) return this.model; // don't re-init every image
    this.loadingModel = true;
    console.log('🚀 Loading TensorFlow model...');
    try {
      if (!tf.getBackend() || tf.getBackend() !== 'webgl') {
        await tf.setBackend('webgl');
        await tf.ready();
      }
      this.model = await cocoSsd.load();
      console.log('✅ Model loaded successfully');
    } catch (err) {
      console.error('❌ Model load failed:', err);
    }
    this.loadingModel = false;
    return this.model;
  }

  uploadSingleImage(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('Image', file);

    var headers = new Headers();
    let user_access_token = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("user_access_token"))
    );
    const token: string = "Bearer " + user_access_token;
    headers.append("Authorization", token);
    let options = new RequestOptions({ headers: headers });

    const apiUrl = environment.apiUrl + '/api/Document/ImageToTextOCRForOrder';

    // return this.anghttp.post(apiUrl, formData, { headers }).toPromise();
    return this.anghttp.post(apiUrl, formData, { headers })
      .toPromise()
      .then((res: Response) => res.json()) // ✅ parse response body
      .catch((err) => {
        console.error('Upload failed:', err);
        throw err;
      });
  }

  viewEIR(element: any) {
    if (!element.eircopy) {
      this.toastr.error("No image available.", "Error");
      return;
    }

    // Create object URL
    const url = URL.createObjectURL(element.eircopy);

    // Open in new tab/window
    window.open(url);

    // Optional: revoke the URL after some time to free memory
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }

   onActionClick({ row, actionName , index}) {
    if (actionName.trim() == 'Edit') {
      this.OnEditOrder(index,row);
      console.log(actionName,row);
    }else if(actionName.trim() == 'Delete'){
      this.OnDeleteOrder(index,row);
      console.log(actionName,row);
    }
   }

  OnDeleteOrder(i: any, data: any){
    this.OCRExtractedData.splice(i, 1);
    this.tableDetails.data.splice(i, 1);
    var up_success = this.OCRExtractedData.filter(x => x.IsUploadSuccess === true).length;
    this.UploadedData.UploadSuccess = up_success;
    this.UploadedData.UploadFailed = parseFloat(this.OCRExtractedData.length) - parseFloat(up_success);
  }

  resetData() {
    this.OCRExtractedData = [];
    this.tableDetails.data = [];
    this.UploadedData.TotalFiles = 0;
    this.UploadedData.UploadSuccess = 0;
    this.UploadedData.UploadFailed = 0;
  }

  OnEditOrder(i: any, data: any) {
    this.selectedData = {};
    this.selectedIndex = 0;
    this.selectedData = data;
    this.selectedIndex = i;
    this.modalRef = this.modalService.open(this.EditOrder, { centered: true, size: "lg" });
    console.log('selectedData',this.selectedData);
  }

  UpdateParent(event){
    if(event){
      this.OCRExtractedData[this.selectedIndex] = event;
      this.tableDetails.data[this.selectedIndex] = event;
      this.toastr.success('Edited Successsfully!', 'Success');
      this.selectedData = {};
      this.selectedIndex = 0;
    }
  }

  isSaving: boolean = false;
  ContainerNoList: any = [];
  async confirmOrder() {
    if (!this.ValidateOCR()) {
      return;
    }

    Helpers.setLoading(true)
    this.isSaving = true;
    // Build FormData instead of JSON payload
    const formData = new FormData();

    // Prepare data array
    const payload: any[] = [];

    this.tableDetails.data.forEach((ocr, index) => {
      const tripdate = ocr.tripDate ? new Date(ocr.tripDate) : this.today;

      const obj: any = {
        ContainerNo: ocr.containerNumber,
        SealNo: ocr.sealNumbers,
        Scan: ocr.scanLines,
        Customer: ocr.customer,
        Destination: ocr.destination,
        VehicleNo: ocr.truckNumber,
        VehicleSize: ocr.size,
        TransportService: ocr.transportService,
        CompanyId: this.CompanyId,
        UserId: this.userId,
        Weight: ocr.weight,
        Remarks: ocr.singleLineText.replace("<", ""),
        TripDate: this.datepipe.transform(tripdate, 'dd-MMM-yyyy HH:mm') || '',
        ISOCode: ocr.isoCode,
        Status: ocr.status,
        Temp: ocr.temp,
        HeaderName: ocr.headerName,
        Origin: ocr.origin,
        DieselTaken: ocr.dieselTaken,
        DriverId: ocr.driverId,
        eircopyField: `${ocr.containerNumber}_${index}` // 👈 Reference the file field name
      };

      payload.push(obj);

      // Attach the image file as a FormData field
      if (ocr.eircopy && ocr.eircopy instanceof File) {
        formData.append(`${ocr.containerNumber}_${index}`, ocr.eircopy, `${ocr.containerNumber}_${index}.jpeg`);
      }
    });

    // Add JSON string of all metadata
    formData.append("payload", JSON.stringify(payload));

    var headers = new Headers();
    let user_access_token = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("user_access_token"))
    );
    const token: string = "Bearer " + user_access_token;
    headers.append("Authorization", token);
    let options = new RequestOptions({ headers: headers });

    // Send via FormData
    this.anghttp.post(`${environment.apiUrl}/api/Document/OCRAutomateTripProcess`, formData, { headers })
      .map((res: Response) => res.json())
      .subscribe(
        async (response: any) => {
          const successfulItems = response.Table.filter(item => item.isDone === 'OK');
          const failedItems = response.Table.filter(item => item.Reason !== 'OK');

          const keys = Object.keys(response);
          var lastKey = keys[keys.length - 1];
          const lastTableCount = Array.isArray(response[lastKey]) ? response[lastKey].length : 0;
          const lastTable = response[lastKey];
          let recordCountValue: number | null = null;
          let missingContainerNo: string | null = null;
          let missingContainerList: { key: string, value: string }[] = [];

          if (Array.isArray(lastTable) && lastTable.length > 0) {
            const firstRow = lastTable[0];
            if ('RecordCount' in firstRow) {
              recordCountValue = firstRow.RecordCount;
            }
            if ('MissingContainerNo' in firstRow) {
              missingContainerNo = firstRow.MissingContainerNo;
              if (missingContainerNo && missingContainerNo.trim() !== '') {
                missingContainerList = missingContainerNo
                  .split(',')
                  .map(c => ({
                    key: 'ContainerNo',
                    value: c.trim()
                  }));
              }
            }
          }

          if (successfulItems.length > 0) {
            // build success message
            const savedCount = (recordCountValue !== null && recordCountValue !== undefined)
              ? recordCountValue
              : 0;
            const totalCount = lastTableCount;

            // ✅ Show toast message
            this.toastr.success(
              `Out of ${savedCount}, ${totalCount} order saved successfully`,
              'Success'
            );

            // this.toastr.success('Data saved successfully', 'Success');
            if (missingContainerList.length > 0) {
              const table1 = (response[keys[totalCount]] || []).filter((t: any) => t.Reason !== 'OK');
              missingContainerList = missingContainerList.map(item => {
                const match = table1.find((t: any) => t.ContainerNo === item.value);
                return {
                  ...item,
                  reason: match ? match.Reason : null
                };
              });

              this.ContainerNoList = [];
              this.ContainerNoList = missingContainerList;

              const missingContainerNos = this.ContainerNoList.map(c => c.value);
              this.tableDetails.data = this.tableDetails.data
                .filter(item => missingContainerNos.includes(item.containerNumber))
                .map(item => {
                  const match = this.ContainerNoList.find(c => c.value === item.containerNumber);
                  return {
                    ...item,
                    Reason: match ? match.reason : item.Reason   // update Reason from ContainerNoList
                  };
                });

              this.UploadedData.UploadSuccess = this.OCRExtractedData.length;
              this.UploadedData.UploadFailed = 0;

              this.isSaving = false;
              this.modalRef = this.modalService.open(this.failedModal, { centered: true, size: "lg" });
              // $("#failedModal").modal('show');
              // $("#failedModal").appendTo("body").modal({
              //   show: true,
              //   backdrop: 'static',
              //   keyboard: false
              // });
            } else {
              this.OCRExtractedData = [];
              this.tableDetails.data = [];
              this.Cancel();
              this.OnRefreshParent.emit('true');
            }
          }

          setTimeout(() => {
            if (failedItems.length > 0 && successfulItems.length == 0) {
              const errorMessages = failedItems
                .map((msg, idx) => `Error ${idx + 1}: ${msg.Reason ? msg.Reason.replace(/\\,/g, ',') : ''}`)
                .join('\n');

              this.toastr.error(errorMessages, 'Error');

              // map to desired format
              const failedContainerList: { key: string; value: string; reason: string }[] = failedItems.map(item => ({
                key: 'ContainerNo',
                value: item.ContainerNo,
                reason: item.Reason
              }));

              // assign to your component property
              this.ContainerNoList = failedContainerList;

              const missingContainerNos = this.ContainerNoList.map(c => c.value);
              this.tableDetails.data = this.tableDetails.data
                .filter(item => missingContainerNos.includes(item.containerNumber))
                .map(item => {
                  const match = this.ContainerNoList.find(c => c.value === item.containerNumber);
                  return {
                    ...item,
                    Reason: match ? match.reason : item.Reason   // update Reason from ContainerNoList
                  };
                });

              this.UploadedData.UploadSuccess = this.OCRExtractedData.length;
              this.UploadedData.UploadFailed = 0;

              this.isSaving = false;
              this.modalRef = this.modalService.open(this.failedModal, { centered: true, size: "lg" });
              // $("#failedModal").modal('show');
              // $("#failedModal").appendTo("body").modal({
              //   show: true,
              //   backdrop: 'static',
              //   keyboard: false
              // });
            }
          }, 1000);

          Helpers.setLoading(false);
          this.isSaving = false;
        },
        async (err) => {
          Helpers.setLoading(false);
          this.isSaving = false;
          this.toastr.error('Error occurred while saving data!', 'Error');
        }
      );
  }

   ValidateOCR(): boolean {
    for (let index = 0; index < this.tableDetails.data.length; index++) {
      const ocr = this.tableDetails.data[index];
      const rowNumber = index + 1;

      if (!ocr.containerNumber) {
        this.toastr.warning(`Please enter container number at row ${rowNumber}`);
        return false;
      }

      if (!ocr.tripDate) {
        this.toastr.warning(`Please select trip date at row ${rowNumber}`);
        return false;
      }

      if (!ocr.customer) {
        this.toastr.warning(`Please select customer at row ${rowNumber}`);
        return false;
      }

      if (!ocr.destination) {
        this.toastr.warning(`Please select destination at row ${rowNumber}`);
        return false;
      }

      if (!ocr.origin) {
        this.toastr.warning(`Please select origin at row ${rowNumber}`);
        return false;
      }

      if (!ocr.truckNumber) {
        this.toastr.warning(`Please enter vehicle number at row ${rowNumber}`);
        return false;
      }

      if (!ocr.size) {
        this.toastr.warning(`Please select vehicle size at row ${rowNumber}`);
        return false;
      }

      if (!ocr.transportService) {
        this.toastr.warning(`Please select transport service at row ${rowNumber}`);
        return false;
      }

      if (!ocr.weight) {
        this.toastr.warning(`Please enter weight at row ${rowNumber}`);
        return false;
      }

      // Example: Trip date must be a valid date
      if (isNaN(Date.parse(ocr.tripDate))) {
        this.toastr.warning('Invalid trip date format.')
        return false;
      }

      const containerRegex = /^[A-Z]{3}U\d{7}$/;
      if (!ocr.containerNumber || !containerRegex.test(ocr.containerNumber)) {
        this.toastr.warning(`Invalid container number at row ${rowNumber}. Format should be like "XXXU0000000", “XXXU” Alpha and 7 digit number. Last “U” character must be there in container no`);
        return false;
      }

      const vehicleRegex = /^[A-Z]{2}\d{2}[A-Z]{1,2}\d{4}$/;
      if (!ocr.truckNumber || !vehicleRegex.test(ocr.truckNumber)) {
        this.toastr.warning(`Invalid vehicle number at row ${rowNumber}. Format should be like "XX00AA0000" or "XX00A0000"`);
        return false;
      }

    }

    return true;
  }
}
